var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 104,
    viewBox: "0 0 96 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4664 16.9999C63.0887 16.9999 74.9425 28.8644 74.9425 43.4999C74.9425 58.1353 63.0887 69.9999 48.4664 69.9999C33.8439 69.9999 21.9901 58.1353 21.9901 43.4999C21.9901 28.8644 33.8439 16.9999 48.4664 16.9999Z",
    fill: "#FF4361"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4664 16.9999C63.0887 16.9999 74.9425 28.8644 74.9425 43.4999C74.9425 58.1353 63.0887 69.9999 48.4664 69.9999C33.8439 69.9999 21.9901 58.1353 21.9901 43.4999C21.9901 28.8644 33.8439 16.9999 48.4664 16.9999Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9722 0.999936H52.9631C69.5168 0.999936 82.9362 14.4311 82.9362 30.9999V40.9999C82.9362 57.5682 69.5168 70.9998 52.9631 70.9998H42.9722C26.4185 70.9998 12.999 57.5682 12.999 40.9999V30.9999C12.999 14.4311 26.4185 0.999936 42.9722 0.999936Z",
    fill: "#FF4361"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9722 0.999936H52.9631C69.5168 0.999936 82.9362 14.4311 82.9362 30.9999V40.9999C82.9362 57.5682 69.5168 70.9998 52.9631 70.9998H42.9722C26.4185 70.9998 12.999 57.5682 12.999 40.9999V30.9999C12.999 14.4311 26.4185 0.999936 42.9722 0.999936Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.908 31.0026C56.8164 30.7972 56.6193 30.6655 56.4021 30.6655H49.7861L56.3156 19.894C56.4244 19.7144 56.4311 19.487 56.3329 19.3015C56.2347 19.1144 56.047 18.9988 55.8437 18.9988H46.9107C46.6992 18.9988 46.5059 19.1236 46.411 19.3214L38.0363 36.8214C37.9498 37.0021 37.9593 37.2166 38.0608 37.3886C38.163 37.5607 38.3422 37.665 38.536 37.665H44.2772L38.0212 53.1891C37.9146 53.4547 38.0095 53.7623 38.2445 53.9133C38.3349 53.9703 38.4354 53.9988 38.5354 53.9988C38.6956 53.9988 38.8536 53.9268 38.9631 53.7918L56.8292 31.6252C56.9694 31.4515 56.9995 31.2085 56.908 31.0026Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.990112,
    y: 9,
    width: 94.9524,
    height: 95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.117647 0 0 0 0 0.435294 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 52.5978,
    y1: 102.635,
    x2: 107.605,
    y2: 39.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC4E9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 53.3761,
    y1: 113.413,
    x2: 125.385,
    y2: 30.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC4E9C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature-2.0ccb635846d4452830ac2cdfb4798665.svg";
export { ForwardRef as ReactComponent };